module.exports = __webpack_public_path__ + "static/media/pasta.6fa5b156.mp3";